import React, { useState, useEffect } from "react";
import { PageLayout } from "../components/page-layout";
import { useLocation, useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getEventById } from "../services/event-service";
import EventCreateEdit from "../components/events/event-create-edit";
import ExceptionMessage from "../components/shared/exception-message";

export const EventEditPage = () => {
  const { state } = useLocation();
  let { id } = useParams();
  const [event, setEvent] = React.useState(state?.event || null);
  const { getAccessTokenSilently } = useAuth0();
  const [eventLoadingError, setEventLoadingError] = useState(null);

  useEffect(() => {
          if (!id) return; 
          const retrieveEvent = async () => {
              const token = await getAccessTokenSilently();
                  const result = await getEventById(token, id);
                  setEvent(result.data);
              if (result.error) {
                  console.error("Error retrieving event:", result.error);
                  setEventLoadingError(result.error);
              }            
          }
          retrieveEvent();
      }, [id, getAccessTokenSilently])

  return (
          <PageLayout>
            {eventLoadingError && <div style={{padding: "12px"}}><ExceptionMessage message={"Oh no! There was an issue loading this event."} /></div>}
            {event && !eventLoadingError && <EventCreateEdit event={event} /> }
          </PageLayout>
      )
};